import instance from './axiosInstance';

export const getUsersData = (reqBody, options = {}, http = instance) => {
  return http.post('/appData/users', reqBody, options);
};
